import PageLink from './PageLink';

interface Props {
  current: number;
  totalPages: number;
  setCurrent: (page: number) => void;
  pagingContainer: string;
}

const CustomPagination: React.FC<Props> = ({
  current,
  totalPages,
  setCurrent,
  pagingContainer,
}) => {
  const pageNumbers = [];
  const visiblePages = 4;

  let startPage = Math.max(1, current - Math.floor(visiblePages / 2));
  let endPage = Math.min(totalPages, current + Math.floor(visiblePages / 2));

  if (endPage - startPage < visiblePages - 1) {
    if (startPage === 1) {
      endPage = Math.min(totalPages, startPage + visiblePages - 1);
    } else {
      startPage = Math.max(1, endPage - visiblePages + 1);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <PageLink key={i} page={i} isCurrent={i === current} onClick={setCurrent} />,
    );
  }

  return (
    <nav className={`navigation pagination ${pagingContainer}`} aria-label="Job Listing Navigation">
      <div className="nav-links">
        <PageLink
          isCurrent={false}
          ariaLabel={'Go to the previous page'}
          ariaDisabled={current === 1}
          onClick={() => {
            if (current > 1) {
              setCurrent(current - 1);
            }
          }}
          className={`prev page-numbers ${current === 1 ? 'disabled' : ''}`}
        />

        {startPage > 1 && (
          <>
            <PageLink page={1} isCurrent={false} onClick={setCurrent} />
            {startPage > 2 && <span className="page-numbers dots">…</span>}
          </>
        )}

        {pageNumbers}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="page-numbers dots">…</span>}
            <PageLink page={totalPages} isCurrent={false} onClick={setCurrent} />
          </>
        )}

        <PageLink
          isCurrent={false}
          ariaLabel={'Go to the next page'}
          ariaDisabled={current === totalPages}
          onClick={() => {
            if (current < totalPages) {
              setCurrent(current + 1);
            }
          }}
          className={`next page-numbers ${current === totalPages ? 'disabled' : ''}`}
        />
      </div>
    </nav>
  );
};

export default CustomPagination;
